import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

interface StylesProps {
  position: {
    top: number
    bottom: number
    left: number
  }
  bannerHeight: number
  bannerWidth: number
  focused: boolean
  visible: boolean
}

export const ToolTipStyles = styled.div<StylesProps>`
  position: relative;
  svg {
    cursor: pointer;
  }
  .info_icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .info-icon {
    ${({ focused }) =>
      focused &&
      `
        &::after {
          content: '';
          display: block;
          top: -10px;
          left: -10px;
          border: 3px solid ${theme.primaryColours.aubergine.darkAubergine};
          border-radius: ${theme.borderRadius.pill};
          min-width: 34px;
          min-height: 34px;
          position: absolute;
        }
      `}
  }
  .info-modal-message {
    z-index: 17;
  }
  .info-icon-hidden {
    position: absolute;
    opacity: 0;
    z-index: -1;
  }
  .banner-wrapper {
    display: ${({ visible }) => (visible ? 'unset' : 'none')};

    position: absolute;
    top: -${({ bannerHeight }) => bannerHeight + 25}px;
    left: -20px;

    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      &.out-of-bounds {
        left: -${({ bannerWidth }) => bannerWidth - 30}px;

        .info-modal-message {
          z-index: 17;
          &:before {
            left: ${({ bannerWidth }) => bannerWidth - 30}px;
          }
        }
      }
    }
    @media (max-width: ${theme.grid.resolution.tablet.width - 1}px) {
      width: 100vw;
      left: -${props => props.position.left}px;
      .info-modal-message {
        &:before {
          left: ${props => props.position.left}px;
        }
      }
    }
  }
`
